import type {ReactElement} from 'react';
import React from 'react';
import type {ColorStorage} from '@Components/color-picker-v2';
import type {RGBA} from '@Utils/color.util';
import {PosterEditingBaseColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-color-panel';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromQRItem} from '@Hooks/poster-editor/useGetKeyFromQRItem';

export function QrBackgroundColorPanel(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const itemQrBackgroundColor = useGetKeyFromQRItem('qrBackgroundColor');

  if (!activeItem || (activeItem && !('qrBackgroundColor' in activeItem)) || !itemQrBackgroundColor) {
    throw new Error(`QR Item doesn't have qrBackgroundColor property`);
  }

  const getBackgroundFillColors = (): ColorStorage[] => {
    return [
      {
        id: 'primary',
        color: itemQrBackgroundColor,
      },
    ];
  };

  const updateQrBackgroundColor = (qrBackgroundColor: RGBA, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        qrBackgroundColor,
      },
      {
        undoable,
      }
    );
  };

  const onChangeBackgroundColorFill = (updatedColor: ColorStorage[]): void => {
    updateQrBackgroundColor(updatedColor[0].color, false);
  };

  const onChangeColorEnded = (updatedColor: ColorStorage[]): void => {
    updateQrBackgroundColor(updatedColor[0].color);
  };

  return (
    <PosterEditingBaseColorPanel
      id="qr-background-color-fill-panel"
      color={getBackgroundFillColors()}
      onChangeColor={onChangeBackgroundColorFill}
      onChangeEnded={onChangeColorEnded}
      isGradientEnabled={false}
    />
  );
}
